import { Configuration, LogLevel, RedirectRequest } from '@azure/msal-browser'
import { MSAL_CLIENT_ID, MSAL_SCOPE, MSAL_TENANT_ID } from '@/constants'
import { Paths } from '@/paths'

export const msalConfig: Configuration = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${MSAL_TENANT_ID}`,
    redirectUri: Paths.HOME,
    postLogoutRedirectUri: Paths.HOME
  },
  cache: {
    // Use "localStorage" to persist the token across browser tabs
    cacheLocation: 'localStorage'
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPersonallyIdentifiableInformation: boolean) => {
        if (containsPersonallyIdentifiableInformation) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            // eslint-disable-next-line no-console
            console.error(message)
            return
          case LogLevel.Info:
            // eslint-disable-next-line no-console
            console.info(message)
            return
          case LogLevel.Verbose:
            // eslint-disable-next-line no-console
            console.debug(message)
            return
          case LogLevel.Warning:
            // eslint-disable-next-line no-console
            console.warn(message)
            return
          default:
            return
        }
      }
    }
  }
}

export const loginRequest: RedirectRequest = {
  scopes: [MSAL_SCOPE]
}
